import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Diamonds from './pages/Diamonds';
import Education from './pages/Education';
import Community from './pages/Community';
import Leather from './pages/Leather';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import NotFound from './pages/NotFound';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/diamonds" element={<Diamonds />} />
          <Route path="/education" element={<Education />} />
          <Route path="/community" element={<Community />} />
          <Route path="/leather" element={<Leather />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<Legal page="privacy" />} />
          <Route path="/terms-of-use" element={<Legal page="terms" />} />
          <Route path="/cookie-policy" element={<Legal page="cookies" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
